import type { GatsbyBrowser } from 'gatsby';
import 'prismjs/themes/prism-tomorrow.css';
// Tailwind must be at the end to allow css overwrite
import './src/styles/tailwind.css';

declare global {
  interface Window {
    dev?: boolean;
    mitchScriptCreatePixel?: () => void;
  }
}

export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = () => {
  if (process.env.NODE_ENV === 'production' || window.dev === true) {
    if (!window.mitchScriptCreatePixel) {
      return;
    }

    window.mitchScriptCreatePixel();
  }
};
